export default __webpack_public_path__ + "static/media/Milk2Icecream_00.7be000b6.png";